import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import LinearProgress from '@mui/material/LinearProgress';
import colors from '../../../../../../../constants/colors'

export default function SmoothLinearProgress({ refreshFrequency }) {
  const useStyles = makeStyles({
    root: {
      width: '100%'
    },
    colorPrimary: {
      backgroundColor: '#FFF !important',
    },
    bar1Indeterminate: {
      width: 'auto',
      animation: `$indeterminate1 ${refreshFrequency}s linear forwards`,
      backgroundColor: colors.blue
    },
    bar2Indeterminate: {
      display: 'none'
    },
    '@keyframes indeterminate1': {
      '0%': {
        left: '-35%',
        right: '100%'
      },
      '100%': {
        left: '0%',
        right: '0%'
      }
    }
  });
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LinearProgress
        classes={{
          bar1Indeterminate: classes.bar1Indeterminate,
          bar2Indeterminate: classes.bar2Indeterminate,
          colorPrimary: classes.colorPrimary
        }}
        variant='indeterminate'
      />
    </div>
  );
}

SmoothLinearProgress.propTypes = {
  refreshFrequency: PropTypes.number.isRequired
};
